var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<h2>Stripe Setup Not Completed</h2><p>It looks like your Stripe account setup wasn't finished or the session expired.</p><p>Please click below to resume your setup.</p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.resumeStripe()\">Resume Stripe Setup</button>";
var id1="stripe-refresh.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;